import _objectDestructuringEmpty from '@babel/runtime/helpers/esm/objectDestructuringEmpty';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { forwardRef } from 'react';
import { Button as Button$1, Box, IconButton as IconButton$1 } from '@chakra-ui/react';
import { Text } from '@outdoorly/text';
import { buildUrlObject } from '@outdoorly/util';
import Link from 'next/link';
import { XIcon } from '@outdoorly/icons';

var _excluded = ["onClick", "children", "colorScheme", "variant", "fontSize", "leading"],
  _excluded2 = ["route", "params", "prefetch"],
  _excluded3 = ["href"],
  _excluded4 = ["size", "onClick", "aria-label"];
var Button = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var onClick = _ref.onClick,
    children = _ref.children,
    _ref$colorScheme = _ref.colorScheme,
    colorScheme = _ref$colorScheme === void 0 ? 'gray' : _ref$colorScheme,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'outline' : _ref$variant,
    fontSize = _ref.fontSize,
    leading = _ref.leading,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Button$1, _extends({
    ref: ref,
    onClick: onClick,
    colorScheme: colorScheme,
    role: "button"
  }, variant === 'link' && {
    textDecoration: 'underline',
    borderRadius: 0,
    paddingX: 0
  }, {
    variant: variant
  }, props), /*#__PURE__*/React.createElement(Text, {
    as: "span",
    size: fontSize,
    color: "inherit",
    leading: leading,
    fontWeight: 'medium'
  }, children));
});
if (process.env.NODE_ENV === 'development') {
  Button.displayName = 'Button';
}
/**
 * A Next.js `<Link><a>` tag combo that looks & behaves like a `<Button>`. For
 * external links, use `<ButtonLink>`.
 */
var ButtonNextLink = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var route = _ref2.route,
    _ref2$params = _ref2.params,
    params = _ref2$params === void 0 ? {} : _ref2$params,
    prefetch = _ref2.prefetch,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Link, {
    prefetch: prefetch,
    href: buildUrlObject({
      route: route,
      params: params
    }),
    passHref: true
  }, /*#__PURE__*/React.createElement(Button, _extends({
    as: "a",
    width: "full"
  }, props, {
    ref: ref
  })));
});
if (process.env.NODE_ENV === 'development') {
  ButtonNextLink.displayName = 'ButtonNextLink';
}
/**
 * An `<a>` tag that looks & behaves like a `<Button>`. Useful for external
 * links. For internal links, use `<ButtonNextLink>`.
 */
var ButtonLink = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var href = _ref3.href,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(Box, {
    as: "a",
    href: href,
    display: "inline-flex",
    ref: ref
  }, /*#__PURE__*/React.createElement(Button, _extends({
    as: "div",
    flexGrow: 1
  }, props)));
});
if (process.env.NODE_ENV === 'development') {
  ButtonLink.displayName = 'ButtonLink';
}
var IconButton = /*#__PURE__*/forwardRef(function (_ref4, ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref4), _ref4));
  return /*#__PURE__*/React.createElement(IconButton$1, _extends({
    paddingX: 0
  }, props, {
    ref: ref
  }));
});
if (process.env.NODE_ENV === 'development') {
  IconButton.displayName = 'IconButton';
}
var iconSize = {
  xs: 3,
  sm: 5,
  md: 7,
  lg: 9
};
/**
 * A chakra-style close button with Feather icon to match Outdoorly designs.
 */
var ODCloseButton = function ODCloseButton(_ref5) {
  var size = _ref5.size,
    onClick = _ref5.onClick,
    ariaLabel = _ref5['aria-label'],
    props = _objectWithoutProperties(_ref5, _excluded4);
  return /*#__PURE__*/React.createElement(IconButton$1, _extends({
    onClick: onClick,
    "aria-label": ariaLabel,
    size: size,
    icon: /*#__PURE__*/React.createElement(XIcon, {
      width: iconSize[size] || 6,
      height: iconSize[size] || 6
    }),
    variant: "ghost",
    py: 3,
    px: 1 //override default
    ,
    _hover: {
      background: 'rgba(0, 0, 0, 0.06)'
    }
  }, props));
};

export { Button, ButtonLink, ButtonNextLink, IconButton, ODCloseButton };
